module.exports = __webpack_public_path__ + "TB_Powerup_Ambience_A.wav.a9e2a745.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_up/TB_Powerup_Ambience_A.wav.mp3
// module id = 502
// module chunks = 0